export const apiRoutes = {
	// quote details endpoints //
	SERVICELEVELS: "carrier-selection/service-levels",
	FREIGHTCLASSES: "create-quote/freight-classes",
	ACCESSORIALS: "create-quote/accessorials",
	UNITTYPES: "create-quote/unit-types",
	STATES: "create-quote/states",
	SERVICEAREATYPES: "carrier-selection/service-area-types",
	CARRIERPRICETYPES: "carrier-selection/carrier-price-types",
	HOLIDAYS: "create-quote/getHolidays?returnFutureHolidays=",
	CUSTOMERSEARCH: "create-quote/customers?nameBeginsWith=:userInput",
	CUSTOMER: "create-quote/customers/:customerId",
	SELECTCUSTOMER: "create-quote/customers/",
	BROKER:
		"create-quote/account-reps?brokerId=:brokerId&mode=LTL&customerId=:customerId",
	ZIPCODESELECT: "create-quote/v2/postal-codes",
	ITEMS: "create-quote/commodity-templates",
	CALCULATEITEMTOTALS: "create-quote/calculate-item-totals",
	QUOTE: "create-quote/quote",
	CUSTOMERQUOTE: "create-quote/customer-quote",
	GETQUOTE: "create-quote/quotes",
	GETCUSTOMERQUOTE: "create-quote/customer-quotes",
	BULKUPLOAD: "create-quote/bulk-quotes",
	BULKTENDERUPLOAD: "create-quote/bulk-tenders",
	REQUOTEQUOTE: "create-quote/quotes/:quoteId/requote",
	EXTERNALREQUOTEQUOTE: "create-quote/customer-quotes/:quoteId/requote",
	COUNTRIES: "create-quote/countries",
	SAVEDCOMMODITIES: "create-quote/commodity-templates?customerId=:customerId",
	CUSTOMERSAVEDCOMMODITIES: "create-quote/customer-commodity-templates",
	UPDATESAVEDCOMMODITIES: "create-quote/commodity-templates/:id/update",
	DELETESAVEDCOMMODITY: "create-quote/commodity-templates/:id",
	ADDRESSBOOK: "address-book-items/v2/customer/:customerId",
	EXTERNALADDRESSBOOK: "external-address-book-items/v2/customer",
	ADDRESSBOOKSUMMARIES: "address-book-items/v2/summaries",
	EXTERNALADDRESSBOOKSUMMARIES: "external-address-book-items/v2/summaries",
	ADDRESSBOOKSEARCH:
		"address-book-items/v2/search?searchTerm=:searchTerm&customerId=:customerId",
	EXTERNALADDRESSBOOKSEARCH:
		"external-address-book-items/v2/search?searchTerm=:searchTerm",
	ADDRESSBOOKITEM: "shipment-details/addressbookitems/:id",
	ADDRESSBOOKITEMV2: "address-book-items/v2/:id",
	EXTERNALADDRESSBOOKITEMV2:
		"external-address-book-items/v2/:addressBookItemId",
	CREATEADDRESSBOOKITEM: "shipment-details/addressbookitems/create",
	CREATEADDRESSBOOKITEMV2: "address-book-items/v2",
	EXTERNALCREATEADDRESSBOOKITEMV2: "external-address-book-items/v2",
	UPDATEADDRESSBOOKITEM: "shipment-details/addressbookitems/:id/update-address",
	DELETEADDRESSBOOKITEM: "shipment-details/addressbookitems/:id/delete",
	DELETEADDRESSBOOKITEMV2: "address-book-items/v2/:addressBookItemId",
	EXTERNALDELETEADDRESSBOOKITEMV2:
		"external-address-book-items/v2/:addressBookItemId",
	UPDATEADDRESSBOOKITEMV2: "address-book-items/v2/:addressBookItemId",
	EXTERNALUPDATEADDRESSBOOKITEMV2:
		"external-address-book-items/v2/:addressBookItemId",
	HAZMATCLASSES: "shipment-details/hazmat-classes",
	HAZMATGROUPS: "shipment-details/hazmat-groups",
	BILLINGCUSTOMERS:
		"shipment-details/customers/:customerId/freight-tendered-customer",

	// shipment details endpoints //
	SHIPMENTDETAILSBYPO: "shipment-details/stops/:poNumber",

	// Carrier Selection Endpoints //
	LEGACYQUOTE: "carrier-selection/quote-id-from-legacy-id",
	CREDITINFO: "carrier-selection/credit-info?customerId=",
	CONTACTINFO: "carrier-selection/users/:brokerId/contact-details",
	SELECTCARRIER: "carrier-selection/:quoteId/select-carrier-price",
	CUSTOMERSELECTCARRIER:
		"carrier-selection/:quoteId/select-customer-carrier-price",
	SEARCHFORCARRIERS:
		"carrier-selection/search-carriers?nameBeginsWith=:userInput",
	ADDINSURANCE: "carrier-selection/quotes/:quoteId/add-insurance",
	ADDCUSTOMERINSURANCE:
		"carrier-selection/customerquotes/:quoteId/add-insurance",
	REMOVEINSURANCE: "carrier-selection/quotes/:quoteId/remove-insurance",
	REMOVECUSTOMERINSURANCE:
		"carrier-selection/customerquotes/:quoteId/remove-insurance",
	GETINSURANCEMARKUP: "carrier-selection/insurance-markup",
	CALCULATEINSURANCEMARKUPS:
		"carrier-selection/quotes/:quoteId/calculate-insurance-markups",
	CALCULATECUSTOMERINSURANCEMARKUPS:
		"carrier-selection/customerquotes/:quoteId/calculate-insurance-markups",
	MARKUPDEFAULTSLTL: "carrier-selection/markupdefaults/ltl",
	MARKUPDEFAULTSPARTIALS: "carrier-selection/markupdefaults/partials",
	UPDATEPRICES: "carrier-selection/:quoteId/update-prices",
	ADDMANUALPRICE: "carrier-selection/quotes/:quoteId/AddManualPrice",
	UPDATECONTRACTEDPRICE:
		"create-quote/quotes/:quoteId/UpdateContractedPrice/:carrierPriceId",
	GETCARRIERTERMINALINFO: "carrier-selection/terminals?",
	GENERATERATECONFIRMATION:
		"carrier-selection/confirmation-report/:public-guid/multiple-rates",

	// shipment summary endpoints //
	FREIGHTCUSTOMER:
		"shipment-details/customers/:customerId/freight-tendered-customer",
	UPDATEQUOTE: "shipment-details/quotes/:quoteId/update-shipment-details",
	UPDATECUSTOMERQUOTE:
		"shipment-details/quotes/:quoteId/update-customer-shipment-details",
	TENDERQUOTE: "shipment-details/quotes/:quoteId/tender-shipment",
	TENDERCUSTOMERQUOTE:
		"shipment-details/quotes/:quoteId/tender-customer-shipment",
	BULKTENDER: "shipment-details/bulk-tender",
	BULKTENDERCUSTOMER: "shipment-details/customer/bulk-tender",
	BULKTENDERDOCUMENTS: "shipment-details/bulk-documents",
	BULKTENDERDOCUMENTSSEND: "shipment-details/bulk-documents/send",
	BULKTENDERDOCUMENTSCUSTOMERSEND:
		"shipment-details/customer/bulk-documents/send",
	// Combined select-carrier-price + tender-shipment in a single call. Used by
	// the LTL Shipment carrier-selection "Tender" (book + tender) flow.
	BOOKTENDERSHIPMENT: "shipment-details/quotes/:quoteId/book-tender-shipment",
	// External (customer) variant of the combined book + tender flow.
	BOOKTENDERCUSTOMERSHIPMENT:
		"shipment-details/quotes/:quoteId/book-tender-customer-shipment",
	// Combined create-quote + update-shipment-details + (optional) add-insurance
	// in a single call. Used by the LTL Shipment "Tender" flow.
	LTLTENDERFLOW: "shipment-details/ltl-tender-flow",
	// External (customer) variant of the combined LTL tender flow.
	LTLTENDERFLOWCUSTOMER: "shipment-details/customer/ltl-tender-flow",
	SHIPPINGLABELREPORT: "shipment-details/shipping-label-report",
	BOLREPORT: "shipment-details/bol-report/:poNumber",
	// Generates the BOL and shipping labels for an existing load using only its
	// PO number (no quote context). Used by the external load board doc flyout.
	GENERATELOADDOCUMENTS: "shipment-details/loads/:poNumber/generate-documents",

	// shipment notifications endpoints //
	SENDDOCS: "shipment-details/notifications/shipping-label-bol/send",
	SENDCUSTOMERDOCS:
		"shipment-details/notifications/customer/shipping-label-bol/send",
	// External docs email with editable recipients (CID-gated behind the
	// `traxLtlPostTenderEmailRecipients` LD flag). Server generates the subject
	// and body; FE supplies recipients and the includeTrackingLink flag.
	SENDCUSTOMERDOCSTORECIPIENTS:
		"shipment-details/notifications/customer/shipping-label-bol/send-to-recipients",
	// Pre-pay tender — success email sent after Braintree SubmitPayment succeeds
	// and before the final tender call. Body: QuoteBOL.
	SENDCUSTOMERPREPAYMENTSUCCESS:
		"shipment-details/notifications/credit-cards-customer-prepayment/send",
	// Pre-pay tender — failure email sent when Braintree SubmitPayment fails.
	// Body: PrepayCustomer { customerName, customerEmail, brokerEmail, ltlBrokerEmail }.
	// TODO: Spec says this lives on the Emails API (env-specific), not the LTL BFF.
	// This codebase has no Emails API client; routing through default base for now.
	// Confirm with backend whether to migrate to BFF or wire up an Emails API client.
	SENDPREPAYTENDERFAILURE: "PrePayTenderFailure",
	SHIPMENTNOTIFICATIONTYPES: "shipmentnotifications/types",
	SHIPMENTNOTIFICATIONRECIPIENTS: "shipmentnotifications/recipients",
	SHIPMENTNOTIFICATIONRECIPIENT: "shipmentnotifications/recipients/:id",
	SHIPMENTNOTIFICATIONRECIPIENTSINDIVIDUAL:
		"shipmentnotifications/recipients/individual",
	SHIPMENTNOTIFICATIONRECIPIENTSINDIVIDUALBULKQUERY:
		"shipmentnotifications/recipients/individual/bulk/query",
	SHIPMENTNOTIFICATIONRECIPIENTSINDIVIDUALBULK:
		"shipmentnotifications/recipients/individual/bulk",
	EXTERNALSHIPMENTNOTIFICATIONTYPES: "customer/shipment-notifications/types",
	EXTERNALSHIPMENTNOTIFICATIONRECIPIENTS:
		"customer/shipment-notifications/recipients",
	EXTERNALSHIPMENTNOTIFICATIONRECIPIENT:
		"customer/shipment-notifications/recipients/:id",
	EXTERNALSHIPMENTNOTIFICATIONRECIPIENTSINDIVIDUAL:
		"customer/shipment-notifications/recipients/individual",
	EXTERNALSHIPMENTNOTIFICATIONRECIPIENTSINDIVIDUALBULKQUERY:
		"customer/shipment-notifications/recipients/individual/bulk/query",
	EXTERNALSHIPMENTNOTIFICATIONRECIPIENTSINDIVIDUALBULK:
		"customer/shipment-notifications/recipients/individual/bulk",

	// quoteBoard endpoints //
	QUOTEBOARD: "quoteboard/items",
	QUOTEBOARDV2: "quoteboard/v2/items",
	CUSTOMERQUOTEBOARD: "quoteboard/customer-items",
	CUSTOMER_UNPROCESSED_BULK: "quoteboard/customer-unprocessed-bulk",
	GETLTLBROKERS: "quoteboard/GetLtlBrokers?nameBeginsWith=:userInput",

	// config endpoints
	CONFIG: "configs",
	CUSTOMER_CONFIG: "customer/configs",
	GETPRIMARYBROKERS: "quoteboard/GetPrimaryBrokers?nameBeginsWith=:userInput",

	// profile endpoints //
	CUSTOMERSBYIDS: "customers/by-ids",

	// loadboard endpoints //
	GETCUSTOMERSBYAR: "customers/by-ltl-broker",
	GETTRACKING: "tracking/:poNumber",
	GETTRACKINGINTERNAL: "tracking/internal/:poNumber",
	GETTRACKINGPUBLIC: "tracking/public/:poNumber",

	// dashboard endpoints //
	EXCEPTIONCOUNTS: "exceptions/counts",
	DASHBOARD_SHIPMENT_MANAGEMENT: "dashboard/shipment-management",
	DASHBOARD_ACCOUNTS_RECEIVABLE: "dashboard/accounts-receivable",
	DASHBOARD_CLAIMS: "dashboard/claims",
	DASHBOARD_SALES_PERFORMANCE: "dashboard/sales-performance",
	DASHBOARD_CARRIERS: "dashboard/carriers",
	DASHBOARD_ACCOUNT_REPS: "dashboard/account-reps",
	// LTL Quoting API (default) - quote/quote-ratio metrics for Sales Performance
	CUSTOMERS_QUOTE_SUMMARY: "customers/quote-summary",
	ADDRESSBOOKHISTORY: "address-book-items/v2/:addressBookItemId/history",
	EXTERNALADDRESSBOOKHISTORY:
		"external-address-book-items/v2/:addressBookItemId/history",

	// payment endpoints //
	GETBRAINTREETOKEN: "payments/client-token",
	GETCUSTOMERBALANCES: "payments/account-balances",
	GETCUSTOMERACCOUNTS: "payments/pay-accounts",
	GETCUSTOMERPAYMENTMETHODS: "payments/get-payment-methods",
	GETCUSTOMEROPENINVOICES: "payments/get-open-invoices",
	GETCUSTOMERPAIDINVOICES: "payments/get-paid-invoices",
	GETCUSTOMERALLINVOICES: "payments/get-all-invoices",
	GETCUSTOMERINVOICESUMMARY: "payments/payment-summary",
	POSTPAYACCOUNT: "payments/pay-account",
	POSTSUBMITPAYMENT: "payments/submit-payment",
	GETINVOICESDOCUMENTS: "icab/load-docs/:poNumber",
	GETINVOICEDOCUMENTBYNAME: "icab/Document/:poNumber/:fileName",
	DELETEPAYMENTMETHOD:
		"payments/delete-pay-account/:paymentMerchantCustomerId/:paymentMethodToken",
	POSTPRECREATEPAIDPAYMENT: "payments/create-payment",
	POSTPREMAKEPAIDPAYMENT: "payments/make-payment",
	POSTUPDATEPAYMENTSTATUS: "payments/update-payment-status",

	// account settings endpoints //
	GETBILLINGINFORMATION: "admin/getbillinginformation",
	UPDATEBILLINGINFORMATION: "admin/updatebillinginformation",

	// user management endpoints //
	GETALLTRAXUSERSBYCUSTID:
		"Admin/GetAllTraxUsersByCustID?customerId=:customerId",
	ADDWEBUSER: "Admin/AddWebuser",
	DELETEWEBUSER: "Admin/DeleteWebuser",
	SAVEUSERLOGINEVENTS: "Admin/SaveUserLoginEvents",

	// my settings endpoints //
	GETCURRENTUSERINFO: "admin/GetCurrentUserInfo",
	GETINTERNALCURRENTUSERINFO: "admin/GetCurrentInternalUserInfo",
	UPDATEWEBUSER: "admin/UpdateWebUser",
	UPDATEVENDORWEBUSER: "admin/UpdateVendorWebUser",
	GETMFAPHONENUMBERBYUSER: "Admin/GetMFAPhoneNumberByUser",
	ENABLEMFAFORUSER: "Admin/EnableMFAForUser",
	DISABLEMFAFORUSER: "Admin/DisableMFAForUser",
	ADDMFAPHONENUMBER: "Admin/AddMFAPhoneNumber",
	REMOVESINGLEFAPHONENUMBER: "Admin/RemoveSingleMFAPhoneNumber",

	// feedback routes //
	SUBMITFEEDBACK: "utils/SaveFeedback",
	SUBMITINTERNALFEEDBACK: "utils/SaveInternalFeedback",
	SUBMITVENDORFEEDBACK: "utils/SaveVendorFeedback",

	GETBROKER: "ftl-quote/get-broker-by-customer",
	GET_REQUESTED_RATE_FEATURE: "ftl-quote/requested-rate-feature",

	// trax-ar-api endpoints //
	TEMPLATESEARCH: "templates/search",
	TEMPLATES: "templates",
	DELETETEMPLATE: "templates/:id",
	UPDATETEMPLATE: "templates/:id",
	EXTERNALTEMPLATESEARCH: "customer/templates/search",
	EXTERNALTEMPLATES: "customer/templates",
	EXTERNALDELETETEMPLATE: "customer/templates/:id",
	EXTERNALUPDATETEMPLATE: "customer/templates/:id",

	// reports endpoints //
	SHIPMENTDETAILSREPORT: "reports/shipment-details",
	REPORTS_FEATURE_ACCESS: "reports/feature-access",

	// shipment management endpoints //
	SHIPMENT:
		"shipment-management/internal-legacy-shipment-details?poNumber=:poNumber",
	CUSTOMERSHIPMENT:
		"shipment-management/customer-legacy-shipment-details?poNumber=:poNumber&quoteId=:quoteId",
	GETSHIPMENTDOCUMENTS: "shipment-management/load-docs/:poNumber",
	GETSHIPMENTDOCUMENTBYNAME: "shipment-management/Document/:poNumber/:fileName",
	GETSHIPMENTSTATUSENUMS: "shipment-management/shipment-states",
	POSTNEWREMARK: "shipment-management/internal-remarks/:poNumber",
	PUTDELETEREMARK: "shipment-management/internal-remarks/:poNumber/:remarkId",
	POSTTRACKHISTORY: "shipment-management/tracking-messages/:poNumber",
	PUTDELETETRACKHISTORY:
		"shipment-management/tracking-messages/:poNumber/:trackHistoryId",
	POSTNEWCLAIM: "shipment-management/loads/:poNumber/claims",
	GETCLAIMS: "shipment-management/claim-reasons",
	ADDSHIPMENTINSURANCE: "shipment-management/shipments/:poNumber/add-insurance",
	ADDCUSTOMERSHIPMENTINSURANCE:
		"shipment-management/customer-shipments/:poNumber/add-insurance",
	MARKEXCEPTIONACKNOWLEDGED: "exceptions/:exceptionId/markacknowledged",
	POSTDISPATCH: "shipment-management/internal-dispatch",
	PUTLOCKSHIPMENT: "shipment-management/loads/:poNumber/lock",
	UNLOCKSHIPMENT: "shipment-management/loads/:poNumber/unlock",
	POSTCREATEFLAG: "exceptions/addpersonalflag",
	POSTPHONEDISPATCH: "shipment-management/phone-dispatch",
	POSTMARKLOADED: "shipment-management/mark-shipment-loaded/:poNumber",
	POSTCANCELDISPATCH: "shipment-management/cancel-dispatch",
	POSTMARKDELIVERED: "shipment-management/mark-shipment-delivered/:poNumber",
	POSTMARKUNDELIVERED:
		"shipment-management/mark-shipment-undelivered/:poNumber",
	POSTSENDACCOUNTING: "shipment-management/loads/:poNumber/sent-to-accounting",
	POSTBILLHOLD: "shipment-management/bill-hold",
	POSTBILLHOLDVALIDATION: "shipment-management/bill-hold/validation",
	GETEDISTATUS: "shipment-management/load-compliance-detail",
	POSTMARKUNLOADED: "shipment-management/mark-shipment-unloaded/:poNumber",
	POSTVOIDVALIDATION: "shipment-management/loads/:poNumber/void/validation",
	POSTVOIDUNVOIDSHIPMENT: "shipment-management/loads/:poNumber/void",

	// routing guide endpoints //
	// routingrules controller is AR API, routing-rules controller is BFF
	GETGLOBALROUTINGGUIDES: "routingrules/global",
	GETROUTINGGUIDE: "routingrules/:id",
	POSTGLOBALROUTINGGUIDE: "routingrules",
	PUTGLOBALROUTINGGUIDE: "routingrules/:id",
	DELETEGLOBALROUTINGGUIDE: "routingrules/:id",

	GETCUSTOMERROUTINGGUIDES: "routingrules/customer/:customerId",
	GETEXTERNALCUSTOMERROUTINGGUIDES: "routing-rules/customer",
	POSTCUSTOMERROUTINGGUIDE: "routingrules/customer",
	PATCHCUSTOMERROUTINGGUIDE: "routingrules/customer/:id",
	DELETECUSTOMERROUTINGGUIDE: "routingrules/customer/:id",
	GETROUTINGGUIDEENUMS: "routingrules/options",

	PUTEXCLUDEGUIDE: "routingrules/:id/exclude/:customerId",
	DELETEEXCLUDEGUIDE: "routingrules/:id/include/:customerId",

	SIMULATEQUOTE: "routing-rules/simulate",
	// auto-dispatch endpoints //
	GETGLOBALAUTODISPATCHABLECARRIERS: "auto-dispatch/carriers/api-eligible",
	GETSELECTEDGLOBALAUTODISPATCHABLECARRIERS: "auto-dispatch/carriers/enabled",
	GETGLOBALAUTODISPATCHABLEACCESSORIALS: "auto-dispatch/accessorials",
	PATCHGLOBALAUTODISPATCHABLECARRIERS: "auto-dispatch/carriers/api-eligible",

	GETCUSTOMERENABLEDCARRIERS:
		"auto-dispatch/customers/:customerId/enabled-carriers",
	DISABLECUSTOMERCARRIER: "auto-dispatch/customer-carriers/disable",
	ENABLECUSTOMERCARRIER:
		"auto-dispatch/customers/:customerId/carriers/:carrierId/disable",
	GETCUSTOMERDISABLEDTENDERUSERS:
		"auto-dispatch/customers/:customerId/tender-users/disabled",
	DISABLECUSTOMERTENDERUSER: "auto-dispatch/customer-tender-users/disable",
	ENABLECUSTOMERTENDERUSER:
		"auto-dispatch/customers/:customerId/tender-users/:tenderUserTypeId/disable",

	// user preferences endpoints //
	USERPREFERENCES: "user-preferences",
	VENDORUSERPREFERENCES: "vendor/user-preferences",
	INTERNALUSERPREFERENCES: "internal/user-preferences",
	ACTIVECUSTOMERPROFILE: "user-preferences/active-customer",
	VENDORACTIVECUSTOMERPROFILE: "vendor/user-preferences/active-customer",

	// Vendor Management endpoints //
	GETVENDORS: "vendor-management/GetAllVendorUsersByCustID",
	ADDVENDOR: "vendor-management/AddVendorWebUser",
	UPDATEVENDOR: "vendor-management/UpdateVendorWebUser",
	DELETEVENDOR: "vendor-management/DeleteVendorWebUser",

	INTERNALGETVENDORS:
		"internal/vendor-management/GetAllVendorUsersByCustID?customerId=:customerId",
	INTERNALADDVENDOR:
		"internal/vendor-management/AddVendorWebUser?customerId=:customerId",
	INTERNALUPDATEVENDOR:
		"internal/vendor-management/UpdateVendorWebUser?customerId=:customerId",
	INTERNALDELETEVENDOR:
		"internal/vendor-management/DeleteVendorWebUser?customerId=:customerId",

	//re-rate endpoints
	POSTNEWRERATE: "shipment-management/quotes/:quoteId/rerate",
	PATCHSHIPMENTRERATE: "shipment-management/internal-legacy-shipment-details",
} as const;
